module.exports = __webpack_public_path__ + "static/media/5835.a3d04eb0.jpg";